import { render, staticRenderFns } from "./ClassesLeaderboardIndividualView.vue?vue&type=template&id=5cea1a3e&scoped=true&"
import script from "./ClassesLeaderboardIndividualView.vue?vue&type=script&lang=js&"
export * from "./ClassesLeaderboardIndividualView.vue?vue&type=script&lang=js&"
import style0 from "./ClassesLeaderboardIndividualView.vue?vue&type=style&index=0&id=5cea1a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea1a3e",
  null
  
)

export default component.exports